import { Box } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

import {
  LocationSearchProperties,
  LocationSuggestionOption,
} from '../../location-search.types';

import { optionStyle } from './option-wrapper.styling';

export type Properties = Exclude<React.HTMLAttributes<HTMLLIElement>, 'key'> & {
  option: LocationSuggestionOption;
  optionTestIdBuilder: LocationSearchProperties['optionTestIdBuilder'];
  component?: React.ElementType;
};

export const OptionWrapper: FC<PropsWithChildren & Properties> = ({
  option,
  optionTestIdBuilder,
  children,
  component = 'li',
  ...rest
}) => {
  return (
    <Box
      component={component}
      sx={optionStyle}
      {...rest}
      data-testid={optionTestIdBuilder?.(option)}
    >
      {children}
    </Box>
  );
};
